import { inject } from '@angular/core';
import { HttpRequest, HttpInterceptorFn, HttpHandlerFn } from '@angular/common/http';
import { v4 as uuidv4 } from 'uuid';
import { EMPTY } from 'rxjs';

import { IdentificationService } from '@/shared/feature/universal-identification/services/identification.service';
import { NavigationService } from '@/shared/services/navigation.service';
import { environment } from '@/environment';

export const HeaderInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const identificationService = inject(IdentificationService);
  const navigationService = inject(NavigationService);
  const conversationId = identificationService.getTokenFromStorage();
  const gcpBaseURL = environment?.gcp?.baseUrl;

  // --data '{
  //   "accountNumber": "812083608",
  //   "siteReference": 18,
  //   "includeMinorOutages": true,
  //   "includePlannedWorks": false
  // }'

  if (req.url.includes(`${gcpBaseURL}/faults/workflow`)) {
    if (conversationId) {
      const uuid = uuidv4();
      const dapiTestActionCode = sessionStorage.getItem('vmo2_zeus_dapiTestActionCode');
      const pingFedAuthenticated = sessionStorage.getItem(identificationService.getPingFedAccessToken()) || null;

      let headers = {
        ...req.headers.getAll,
        ...{
          'Content-Type': 'application/json; charset=utf-8',
          'DAPI-ConversationId': `${conversationId}`,
          'Dapi-Correlationid': uuid,
          'DAPI-ChannelID': environment?.gcp?.dapiChannelId,
          'DAPI-ClientSecret': environment?.gcp?.dapiClientSecret,
          'DAPI-RequestTimestamp': new Date().toISOString(),
          'DAPI-RequestID': uuid,
          'DAPI-OriginatorID': uuid,
          'DAPI-AppID': environment?.gcp?.dapiAppId,
        },
      };

      if (pingFedAuthenticated) {
        const auth = {
          Authorization: `Bearer ${pingFedAuthenticated}`,
          'DAPI-OauthServer': environment.gcp?.oauthServer,
        };

        headers = { ...headers, ...auth };
      }

      if (dapiTestActionCode) {
        headers = { ...headers, ...{ 'DAPI-TestActionCode': dapiTestActionCode } };
      }

      const modifiedRequest = req.clone({
        setHeaders: headers,
      });

      return next(modifiedRequest);
    } else if (!req.url.endsWith(`${environment?.gcp?.identificationUrl}`)) {
      // if no token and not requesting one return toAppStart() to avoid generating 401/403 responses.
      navigationService.toAppStart();
      return EMPTY;
    }
  }
  return next(req);
};
